'use client'

import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

import BillingCompletenessCard from './BillingCompletenessCard'
import { resolveCompletenessItems } from './completenessItems'
import type { BillingCompleteness } from './types'

type DraftCompletenessCardProps = {
  completeness: BillingCompleteness
  onNavigate?: () => void
}

/** The backend's checklist from a draft, with known keys resolved to localized labels and fix links. */
export default function DraftCompletenessCard({ completeness, onNavigate }: DraftCompletenessCardProps) {
  const t = useTranslations('features.BillingComposer')
  const items = useMemo(() => resolveCompletenessItems(completeness.items, t), [completeness.items, t])
  return <BillingCompletenessCard score={completeness.score} items={items} dense onNavigate={onNavigate} />
}
